import { TermIntelligenceUpsell, TransactionIntelligenceUpsell } from '../components/error';

export enum WorkspaceAppPath {
  TermIntelligence = '/term-intelligence',
  TermIntelligenceTrial = '/term-intelligence-trial',
  TransactionIntelligence = '/transaction-intelligence',
  TransactionIntelligenceFreeTrial = '/transaction-intelligence-free-trial',
  FutureFunds = '/fundraising-calendar',
}

export const workspaceUpsellMapping = [
  {
    name: WorkspaceAppPath.TermIntelligence,
    NoAccessComponent: TermIntelligenceUpsell,
    workspaceName: 'Term Intelligence',
  },
  {
    name: WorkspaceAppPath.TermIntelligenceTrial,
    NoAccessComponent: TermIntelligenceUpsell,
    workspaceName: 'Term Intelligence Free Trial',
  },
  {
    name: WorkspaceAppPath.TransactionIntelligence,
    NoAccessComponent: TransactionIntelligenceUpsell,
    workspaceName: 'Transaction Intelligence',
  },
  {
    name: WorkspaceAppPath.TransactionIntelligenceFreeTrial,
    NoAccessComponent: TransactionIntelligenceUpsell,
    workspaceName: 'Transaction Intelligence Free Trial',
  },
];

export const workspacesWithIntercom = [WorkspaceAppPath.TermIntelligence.toString()];
export const trialWorkspaces = [WorkspaceAppPath.TermIntelligenceTrial.toString()];

export const isIntercomEnabled = (name) => workspacesWithIntercom.includes(name) && window._env_.INTERCOM_ENABLED;

export const getForbiddenWorkspaces = (supportedWorkspaces: string[]) => {
  return workspaceUpsellMapping.filter((workspace) => !supportedWorkspaces?.find((w) => w === workspace.name));
};

export const findWorkspaceByName = (name) => workspaceUpsellMapping.find((workspace) => workspace.name === name);

export const checkIsTrialWorkspace = (name) => trialWorkspaces.includes(name);
